import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAccessMutation } from '../../../Api/admin';
import Button from '../../../Style-guide/Button';
import Input from '../../../Style-guide/Input';
import Title from '../../../Style-guide/Title';
import AdminAuthWrapper from './style/adminAuthWrapper';

const AdminAuth = () => {
  const [adminCode, setAdminCode] = useState('');
  const { mutate: sendCode, isSuccess, data } = useAdminAccessMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSuccess && data?.isAdmin) {
      navigate('/admin/actions', { replace: true });
    }
  }, [data?.isAdmin, isSuccess, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (adminCode.length > 0) {
      sendCode({ data: { adminCode } });
    }
  };

  return (
    <AdminAuthWrapper>
      <div className='content-container'>
        <Title size='SM' className='admin-login-title'>
          Enter the security code
        </Title>

        <Input
          type='password'
          name='passCode'
          className='admin-verification-input'
          value={adminCode}
          onChange={(e) => setAdminCode(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSubmit(e);
          }}
          autoComplete='off'
        />
        <Button className='submit-btn' onClick={handleSubmit}>
          Verify
        </Button>
      </div>
    </AdminAuthWrapper>
  );
};

export default AdminAuth;
